import React from "react";
import { Box, Typography } from "@mui/material";

// Previously hardcoded to "Soham". Now takes the real user so it works
// for whoever is logged in. In NewDashboard.jsx you already pull
// `const { user } = useSelector((state) => state.user)` — just pass
// user?.name (or user?.username as a fallback) in as the `name` prop.
export default function Greeting({ name }) {
    const displayName = name || "there";

    const hour = new Date().getHours();
    const timeOfDay =
        hour < 12 ? "Morning" : hour < 17 ? "Afternoon" : "Evening";

    return (
        <Box sx={{ mb: 4 }}>
            <Typography
                sx={{
                    fontSize: 32,
                    fontWeight: 600,
                    color: "#0F172A",
                    lineHeight: "49.4px",
                }}
            >
                Good {timeOfDay}, {displayName}
            </Typography>
        </Box>
    );
}